var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"recommendation-block mb-2 pb-1 pt-2"},[_c('Info',{attrs:{"recommendation":_vm.recommendation},on:{"toggleResponse":_vm.toggleResponses,"toggleFinding":_vm.toggleFindings}}),_c('RecommendationText',{attrs:{"recommendation":_vm.recommendation,"showResponses":_vm.showResponses,"showFindings":_vm.showFindings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }